<!-- Translated: yes -->
<template>
  <div :class="'wrapper theme--' + theme" v-show="showTimeLine || showBookingTimer">
    <div class="flex" v-if="showTimeLine">
      <ul class="timeline" id="timeline" aria-label="Avklarade steg i bokningen">
        <li :class="'li complete--' + (step.complete) + ' next-complete--' + (steps[key + 1] ? steps[key + 1].complete : '')" v-for="(step, key) in steps" :key="key">
          <!--<div class="timestamp">
            <span class="author">Abhi Sharma</span>
            <span class="date">11/15/2014</span>
          </div>-->
          <div :class="{status: true, clickable: clickable(step)}" @click="goTo(step)">
            <strong>{{step.title}}</strong>
          </div>
        </li>
       </ul>
     </div>
     <BookingTimer v-show="showBookingTimer" @update="update" ref="bookingTimer"></BookingTimer>
  </div>
</template>

<script>
import BookingTimer from '@/components/components/BookingTimer';

export default {
  components: {
    BookingTimer,
  },
  props: {
    steps: {},
    theme: {
      default: 'dark',
    },
    showTimeLine: {
      default: true,
    },
    showBookingTimer: {
      default: true,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    clickable(step) {
      return (step.complete === 2 && step.url) || step.clickable;
    },
    goTo(step) {
      if (this.clickable(step)) {
        this.$router.push(step.url);
      }
    },
    update(value) {
      if (value >= 0) {
        this.showBookingTimer = true;
      } else {
        this.showBookingTimer = false;
      }
    },
  },
  computed: {
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.wrapper
  padding-top 40px
  margin-bottom 40px
  height 100px
  max-width 100%
  &:empty
    display: none
  +max-mobile()
    transform scale(0.65)
    margin-bottom 10px

.timeline
  list-style-type: none
  display: flex
  align-items: center
  justify-content: center
ul
  padding-left 0
  max-width 100%
.li
  transition: all 200ms ease-in
  width 180px

.timestamp
  margin-bottom: 20px
  padding: 0px 40px
  display: flex
  flex-direction: column
  align-items: center
  font-weight: 100
.status
  padding: 0px // 40px
  display: flex
  justify-content: center
  // border-top: 12px solid #ecf5f8
  position: relative
  transition: all 200ms ease-in
  &.clickable
    cursor pointer
  strong
    font-weight: 600
    font-family: Interstate;
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 0.5px;
    text-align: center;
    color: #262626;
    display: block
    margin: 10px 0
    uppercase()
    padding-top 20px
    width 100%
    .theme--light &
      color white
  &:after
    content: ''
    width: 36px;
    height: 36px;
    background-color: #ecf5f8;
    border: 5px solid rgba(191, 217, 225, 0.16);
    border-radius: 25px
    position: absolute
    top: -25px
    left: calc(50% - 24px);
    transition: all 200ms ease-in

  &:before
    content: ''
    height: 12px
    background-color #ecf5f8
    width 100%
    position absolute
    left 0
    top -12px
    margin-left 50%
.li.complete--1
  .status
    &:before
      // background-color: #d99906
    &:after
      background-color: #edb63a;
      border-color: #d99906
      transition: all 200ms ease-in
.li.complete--2.li.next-complete--1,
.li.complete--2.li.next-complete--2,
.li.complete--1.li.next-complete--2
  .status
    &:before
      background-color: #c7dcb7
.li.complete--2
  .status
    &:after
      background-color: #ffffff;
      background-image url(https://static.booking.branasgruppen.se/static/svg/check-round-green.svg)
      background-size 90%
      background-position center
      border-color: #c7dcb7
      transition: all 200ms ease-in
.li:last-child
  .status
    &:before
      display none

.wrapper .flex
  width: 100%
  height: 100%
  display: flex
  justify-content: center

button
  position: absolute
  width: 100px
  min-width: 100px
  padding: 20px
  margin: 20px
  font-family: 'Titillium Web', sans serif
  border: none
  color: white
  font-size: 16px
  text-align: center
#toggleButton
  position: absolute
  left: 50px
  top: 20px
  background-color: #75C7F6

</style>



// WEBPACK FOOTER //
// Timeline.vue?50458330